import { useTranslation } from 'react-i18next';

export const loading = 'ROUTE_MONITORING.LOADING';
export const details = 'ROUTE_MONITORING.DETAILS';
export const map = 'ROUTE_MONITORING.MAP';

export const groupBy = 'ORDER_DETAILS.GROUPING.GROUP_BY';
export const driver = 'ORDER_DETAILS.GROUPING.DRIVER';
export const team = 'ORDER_DETAILS.GROUPING.TEAM';
export const route = 'ORDER_DETAILS.GROUPING.ROUTE';

export const unassigned = 'ORDER_DETAILS.GROUPING.UNASSIGNED';
export const noTeam = 'ORDER_DETAILS.GROUPING.NO_TEAM';
export const noRoute = 'ORDER_DETAILS.GROUPING.NO_ROUTE';

export const goToRoutesMonitoring = 'ORDER_DETAILS.GO_TO_ROUTES_MONITORING';
export const failedToFetch = 'ORDER_DETAILS.FAILED_TO_FETCH';

export const priority = 'DISPATCH_LIST.PRIORITY';
export const assignedTo = 'DISPATCH_LIST.ASSIGNED_TO';
export const status = 'DISPATCH_LIST.STATUS';
export const timeWindow = 'DISPATCH_LIST.TIME_WINDOW';
export const orderTag = 'DISPATCH_LIST.ORDER_TAG';
export const tag = 'DISPATCH_LIST.TAG';
export const servicePlanName = 'DISPATCH_LIST.SERVICE_PLAN_NAME';
export const reservedUntil = 'DISPATCH_LIST.RESERVED_UNTIL';
export const requiredSkills = 'DISPATCH_LIST.SKILLS';
export const rank = 'DISPATCH_LIST.RANK';
export const readyForPickup = 'DISPATCH_LIST.READY_FOR_PICKUP';
export const groupFollowers = 'DISPATCH_LIST.GROUP_FOLLOWERS';
export const taskTypeId = 'DISPATCH_LIST.TASK_TYPE';
export const orderCreated = 'DISPATCH_LIST.ORDER_CREATED';
export const nextStop = 'DISPATCH_LIST.NEXT_STOP';
export const lastWayPointEta = 'DISPATCH_LIST.WAY_POINTS_LAST_ETA';
export const lastWayPointCustomerName = 'DISPATCH_LIST.WAY_POINTS_LAST_CUSTOMER_NAME';
export const lastWayPointScheduledAt = 'DISPATCH_LIST.WAY_POINTS_LAST_SCHEDULED_AT';
export const firstWayPointAddressType = 'DISPATCH_LIST.ADDRESS_TYPE_NAME_FIRST';
export const lastWayPointAddressType = 'DISPATCH_LIST.ADDRESS_TYPE_NAME_LAST';

export const collect = 'DISPATCH_LIST.COLLECT';
export const findMeDefaultAddress = 'FIND_ME_DEFAULT_ADDRESS';

export const selectAllTaskTooltip = 'ORDER_DETAILS.SELECT_ALL_DISABLED_TOOLTIP';
export const unselectAll = 'ORDER_DETAILS.UNSELECT_ALL';

export const detailsHeaders = {
	priority,
	assignedTo,
	status,
	lastWayPointEta,
	lastWayPointCustomerName,
	lastWayPointScheduledAt,
	firstWayPointAddressType,
	lastWayPointAddressType,
	timeWindow,
	orderTag,
	tag,
	servicePlanName,
	reservedUntil,
	requiredSkills,
	rank,
	readyForPickup,
	orderCreated,
	groupFollowers,
	taskTypeId,
	nextStop
};

const useOrderExplorerTranslations = () => {
	const { t } = useTranslation();
	return {
		loading: t(loading),
		details: t(details),
		map: t(map),
		goToRoutesMonitoringView: t(goToRoutesMonitoring),
		unassigned: t(unassigned),
		noTeam: t(noTeam),
		noRoute: t(noRoute),
		failedToFetch: t(failedToFetch),
		collect: t(collect),
		findMeDefaultAddress: t(findMeDefaultAddress),
		selectAllTaskTooltip: t(selectAllTaskTooltip),
		unselectAll: t(unselectAll)
	};
};

export default useOrderExplorerTranslations;
